import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function ContactDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", {
        name: form.name,
        email: form.email,
        phone: form.phone || null,
        message: form.message,
      });
      toast.success("Nachricht gesendet", {
        description: "Wir melden uns in Kürze bei Ihnen.",
      });
      setForm({ name: "", email: "", phone: "", message: "" });
      onOpenChange(false);
    } catch (err) {
      toast.error("Fehler", { description: formatApiErrorDetail(err.response?.data?.detail) || err.message });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="letsbau-dialog max-w-lg" data-testid="contact-dialog">
        <DialogHeader>
          <DialogTitle className="text-neutral-900 text-2xl font-light tracking-tight">Kontakt aufnehmen</DialogTitle>
          <DialogDescription className="text-neutral-500">
            Hinterlassen Sie uns Ihre Nachricht — wir antworten werktags innerhalb von 24 Stunden.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-4 mt-2">
          <div className="grid gap-2">
            <Label htmlFor="c-name">Name</Label>
            <Input id="c-name" data-testid="contact-name-input" required value={form.name} onChange={update("name")} />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="grid gap-2">
              <Label htmlFor="c-email">E-Mail</Label>
              <Input id="c-email" data-testid="contact-email-input" type="email" required value={form.email} onChange={update("email")} />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="c-phone">Telefon (optional)</Label>
              <Input id="c-phone" data-testid="contact-phone-input" value={form.phone} onChange={update("phone")} />
            </div>
          </div>
          <div className="grid gap-2">
            <Label htmlFor="c-msg">Nachricht</Label>
            <Textarea id="c-msg" data-testid="contact-message-input" rows={5} required value={form.message} onChange={update("message")} />
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" className="lbtn" onClick={() => onOpenChange(false)} data-testid="contact-cancel-btn">
              Abbrechen
            </button>
            <button type="submit" className="lbtn primary" disabled={submitting} data-testid="contact-submit-btn">
              {submitting ? "Senden..." : "Nachricht senden"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
